import { Fragment } from 'react';

import type { ContentfulData } from '@/integrations/contentful';
import {
  generateSectionKey,
  renderContentfulSection,
} from '@/integrations/contentful';
export const renderSections = (data: ContentfulData[], draftMode?: boolean) => {
  return data.map((section: ContentfulData, i: number) => (
    <Fragment key={generateSectionKey(section, i)}>
      {renderContentfulSection(section, undefined, undefined, draftMode)}
    </Fragment>
  ));
};
